import {useModal} from 'mui-modal-provider';
import {useCallback} from 'react';

const modals = new Map();

export function useUniqueModal() {
  const {showModal, hideModal, updateModal} = useModal();

  return {
    showModal: useCallback(
      (id, component, props) => {
        const _oldId = modals.get(id);
        if (_oldId !== undefined) {
          hideModal(_oldId);
        }

        const result = showModal(component, {
          ...(props || {}),
          onExited: () => {
            if (modals.get(id) === result.id) {
              modals.delete(id);
            }
            if (props.onExited) {
              props.onExited();
            }
          },
        });
        modals.set(id, result.id);

        return result;
      },
      [hideModal, showModal],
    ),

    hideModal: useCallback(
      (id) => {
        const _id = modals.get(id);
        if (_id !== undefined) {
          hideModal(_id);
        }
      },
      [hideModal],
    ),

    updateModal: useCallback(
      (id, props) => {
        const _id = modals.get(id);
        if (_id !== undefined) {
          updateModal(_id, props);
        }
      },
      [updateModal],
    ),
  };
}
